export const translations = {
  fr: {
    welcome: "Bienvenue",
    welcomeMessage: "Bienvenue sur le portail d'archives Hopscotch Groupe.",
    yourContainers: "Vos espaces accessibles",
    noContainers: "Vous n'avez accès à aucun espace pour le moment.",
    logout: "Déconnexion",
    back: "Retour",
    download: "Télécharger",
    search: "Rechercher un fichier...",
    searchButton: "Rechercher",
    clearSearch: "Effacer",
    searchResults: "Résultats de recherche",
    noResults: "Aucun résultat trouvé.",
    loading: "Chargement...",
    error: "Une erreur est survenue.",
    preview: "Prévisualisation",
    close: "Fermer",
    openOffice: "Ouvrir dans Office Online",
    folder: "Dossier",
    file: "Fichier",
    size: "Taille",
    lastModified: "Modifié le",
    selectAll: "Tout sélectionner",
    downloadSelected: "Télécharger la sélection",
    viewList: "Liste",
    viewMosaic: "Mosaïque",
    admin: "Administration",
    adminTitle: "Administration des espaces",
    adminSubtitle: "Gérer les containers et leurs groupes d'accès Entra ID.",
    adminDenied: "Accès refusé. Cette page est réservée aux administrateurs IT.",
    adminExistingContainers: "Containers existants",
    adminNoContainers: "Aucun container configuré pour le moment.",
    adminAddContainer: "Ajouter un container",
    adminContainerName: "Nom du container",
    adminGroupId: "Object ID du groupe Entra",
    adminNameHint: "En minuscules uniquement (ex: rh, finance)",
    adminGroupHint: "L'Object ID du groupe Entra, pas son nom",
    adminAdd: "Ajouter",
    adminAdding: "Ajout...",
    adminSaving: "Enregistrement...",
    adminDelete: "Supprimer",
    adminSaved: "Configuration enregistrée avec succès.",
    adminFillBoth: "Veuillez remplir le nom du container et l'Object ID du groupe.",
    adminAlreadyExists: "Ce container existe déjà.",
    adminWarning: "Important : le container doit d'abord être créé physiquement dans le Storage Account, et le groupe Entra doit exister. Cette page ne fait que le mapping entre les deux. Les utilisateurs membres du groupe verront le container à leur prochaine connexion.",
  },
  en: {
    welcome: "Welcome",
    welcomeMessage: "Welcome to the Hopscotch Groupe archives portal.",
    yourContainers: "Your accessible spaces",
    noContainers: "You do not have access to any space at the moment.",
    logout: "Logout",
    back: "Back",
    download: "Download",
    search: "Search for a file...",
    searchButton: "Search",
    clearSearch: "Clear",
    searchResults: "Search results",
    noResults: "No results found.",
    loading: "Loading...",
    error: "An error occurred.",
    preview: "Preview",
    close: "Close",
    openOffice: "Open in Office Online",
    folder: "Folder",
    file: "File",
    size: "Size",
    lastModified: "Last modified",
    selectAll: "Select all",
    downloadSelected: "Download selection",
    viewList: "List",
    viewMosaic: "Mosaic",
    admin: "Administration",
    adminTitle: "Spaces administration",
    adminSubtitle: "Manage containers and their Entra ID access groups.",
    adminDenied: "Access denied. This page is reserved for IT administrators.",
    adminExistingContainers: "Existing containers",
    adminNoContainers: "No container configured yet.",
    adminAddContainer: "Add a container",
    adminContainerName: "Container name",
    adminGroupId: "Entra group Object ID",
    adminNameHint: "Lowercase only (e.g. rh, finance)",
    adminGroupHint: "The Entra group Object ID, not its name",
    adminAdd: "Add",
    adminAdding: "Adding...",
    adminSaving: "Saving...",
    adminDelete: "Delete",
    adminSaved: "Configuration saved successfully.",
    adminFillBoth: "Please fill in both the container name and the group Object ID.",
    adminAlreadyExists: "This container already exists.",
    adminWarning: "Important: the container must first be physically created in the Storage Account, and the Entra group must exist. This page only maps the two together. Users who are members of the group will see the container at their next login.",
  },
};
